'use strict';

(function () {
    'use strict';

    angular.module('schedules.closedSlot', ['ui.router', 'common']);
})();